import { LinearProgress } from "@material-ui/core";
import * as React from "react";
import "./progressBar.scss";

interface ProgressBarProps {
  value: number;
  maxValue: number;
}

interface ProgressBarState {
  value: number;
  interval?: NodeJS.Timeout;
}

export default class ProgressBar extends React.Component<ProgressBarProps, ProgressBarState> {
  constructor(props: any) {
    super(props);

    this.state = {
      value: props.value
    };
  }

  public componentDidMount() {
    this.setState({ interval: setInterval(this.progress.bind(this), 1200) });
  }

  public componentWillUnmount() {
    clearInterval(this.state.interval!);
  }

  public render() {
    return <LinearProgress className="progress-bar" variant="determinate" value={this.state.value} />;
  }

  private progress() {
    const value = this.props.value > this.state.value ? this.props.value : this.state.value;
    const increment = value + 5;
    const newValue = increment >= this.props.maxValue ? this.props.maxValue : increment;
    this.setState({ value: newValue });
  }
}

